/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react';
import { TableBasic, MediaBadge, ColumnTitle, TeamNameWrapper, TeamNamePopUp } from './styles';
import Media from '../Media/Media';
import { InputCheckbox, Tag, RequestPendingRow } from '..';
import { ARMcontext } from '../../utils/context/context';
import Utils from '../../utils/api/Utils';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';
import { BoldSpan } from './styles';
import dayjs from '../../utils/config/dayjs';
import { dateFormats } from '../../utils/constants/dateFormats';

export function Tooltip({ data, tooltip }: { data: Array<any>; tooltip: any }) {
  if (tooltip?.visible) {
    if (data?.length > 0) {
      return (
        <TeamNamePopUp posX={tooltip.posX} posY={tooltip.posY}>
          {data?.map((item, index) => {
            if (index === data.length - 1) {
              return <div key={item._id + 'popUp' + tooltip.posX}>{item.name}</div>;
            } else {
              return <div key={item._id + 'popUp' + tooltip.posX}>{item.name + ','}</div>;
            }
          })}
        </TeamNamePopUp>
      );
    } else {
      return <></>;
    }
  } else {
    return <></>;
  }
}

function getLocaleShortDate(oldDate: Date) {
  return dayjs(oldDate).format(dateFormats.MDYYYY);
}

function GenerateRow({ element, index, HandleOne, HandleRequest }: { element: any; index: number; HandleOne: any; HandleRequest: any }) {
  const [tooltip, useTooltip] = useState({ visible: false, posX: 0, posY: 0 });
  const { user } = useContext(ARMcontext);
  function changeTooltip(event, value) {
    useTooltip({ visible: value, posX: event.clientX, posY: event.clientY });
  }

  return (
    <tr key={index + element._id}>
      {element.status === 'Pending' &&
        (user?.data?.role === 'org-admin' || user?.data?.isAdmin) &&
        element.invitationType === 'Request' ? (
        <>
          <RequestPendingRow
            age={element.age}
            email={element.email}
            imgUrl={element.picture}
            checked={element.checked}
            invitationID={element._id}
            onCheckbox={() => HandleOne(element)}
            position={element.position}
            callback={HandleRequest}
            name={`${element.firstName} ${element.lastName}`}
            team={element.team}
            status={element.status}
            invitationType={element.invitationType}
          />
        </>
      ) : (
        <>
          <td>
            <MediaBadge>
              <InputCheckbox onClick={() => (HandleOne ? HandleOne(element) : '')} checked={element?.checked || false} />
              <Media imgUrl={element.picture} name={`${element.firstName} ${element.lastName}`} />
            </MediaBadge>
          </td>
          <td>{element.email}</td>
          <TeamNameWrapper
            onMouseEnter={e => changeTooltip(e, true)}
            onMouseLeave={e => changeTooltip(e, false)}
            onWheel={() => useTooltip({ ...tooltip, visible: false })}>
            {element.teams?.map((item, idx) => {
              if (idx === element.team?.length - 1) {
                return <span key={item.name + index}>{item?.name}</span>;
              } else {
                return <span key={item.name + index}>{item?.name + ', '}</span>;
              }
            })}

            <Tooltip data={element.teams} tooltip={tooltip} />
          </TeamNameWrapper>

          <td key={element._id + '-' + index}>
            <Tag name={element.status} theme={element.status} />
          </td>
          <td key={element._id + '_' + index}>
            <ColumnTitle>{element.payment}</ColumnTitle>
          </td>
          <td style={{ textAlign: 'center' }}>
            {element.sponsorshipStartDate ? getLocaleShortDate(element.sponsorshipStartDate) : '-'}
          </td>
          <td style={{ textAlign: 'center' }}>
            {element.sponsorshipEndDate ? element.sponsorshipEndDate === 'lifetime' ? element.sponsorshipEndDate : getLocaleShortDate(element.sponsorshipEndDate) : '-'}
          </td>
        </>
      )}
    </tr>
  );
}
export default ({
  dataTableContent,
  minWidth,
  filter,
  dataMainHead,
  dataTableHead,
  HandleOne,
  HandleAll,
  check,
  selectedTeam,
  individualFilter,
  handleRequest,
  useSort
}: {
  dataTableContent: Array<any>;
  filter: any;
  dataMainHead: Array<any>;
  dataTableHead: Array<{ title: string; colSpan: any; examType: Array<any>; align?: string }>;
  handleClick?: any;
  typeOfTable?: any;
  HandleOne?: any;
  HandleAll?: any;
  check?: any;
  selectedTeam?: string;
  minWidth?: string;
  individualFilter?: any;
  handleRequest?: any;
  useSort?: any;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [reverse, useReverse] = useState<boolean>(true);
  const [isActive, setActiveClass] = useState('');
  const UTILS = new Utils();
  const isWord = UTILS.GetValidationInputPattern();
  const HandleSort = UTILS.HandleSort;
  const sortOptions = [reverse, useReverse, setActiveClass, useTable, table, isWord];

  useEffect(() => {
    const data = dataTableContent
    if (isActive) {
      let exam: any;
      dataTableHead.map(item => {
        if (item.title === isActive) {
          exam = item?.examType;
        }
        return exam;
      });
    } else {
      useTable(data);
    }
  }, [dataTableContent]);

  return (
    <TableBasic minWidth={minWidth}>
      <thead>
        {dataMainHead.length > 0 && (
          <tr>
            {dataMainHead.map((item, index) => (
              <th key={index} colSpan={item.colSpan}>
                {item.title}
              </th>
            ))}
          </tr>
        )}
        <tr>
          {dataTableHead.map((item, index) =>
            item.title === 'PLAYERS' || item.title === 'COACH' ? (
              <th key={index} colSpan={1}>
                <InputCheckbox onClick={() => (HandleAll ? HandleAll(!check) : '')} checked={check} />
                <BoldSpan onClick={() => useSort(item.examType[0])}>
                  {item.title}
                </BoldSpan>
                {isActive === item.title && reverse && <GoChevronDown />}
                {isActive === item.title && !reverse && <GoChevronUp />}
              </th>
            ) : item.title === "INVITATION SENT" ? (
              <React.Fragment key={index}></React.Fragment>
            ) : (
              <th onClick={() => useSort(item.examType[0])} key={index} colSpan={1} style={item.align === 'center' ? { textAlign: "center" } : { textAlign: "left" }}>
                <BoldSpan>{item.title}</BoldSpan>
                {isActive === item.title && reverse && <GoChevronDown />}
                {isActive === item.title && !reverse && <GoChevronUp />}
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody className="table-player-exam">
        {table.length ? (
          table.map((element, index) => (
            <GenerateRow
              element={element}
              index={index}
              HandleOne={HandleOne}
              key={element._id + index}
              HandleRequest={handleRequest}
            />
          ))
        ) : (
          <tr>
            <td colSpan={10} style={{ textAlign: 'center' }}>
              No Data
            </td>
          </tr>
        )}
      </tbody>
    </TableBasic>
  );
};
